import React from 'react';

import Crumbs from './../Crumbs/Crumb';//面包屑
import { Form, Input, Modal, message, Alert } from 'antd';
import "./style.css"
import $ from "jquery"
import http from "./../../../constants/index"
import EventSet from "./../../../assets/PubJs/hcPub"//公用的所有事件
import Chart from "./Bcharts"
import Law from "./Law"
import Notice from "./Notice"
import Node from "./Node"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import createHistory from 'history/createHashHistory'
const history = createHistory();



//外部布局
let _Warp=null;
class App extends React.Component {

    state = {
        hei: 500,
        smWidth:"34%",
        lgWidth:"66%",
        text:'',
        num:[],
    };

    //设置布局
    startSet() {
        let widthWoc = $(document).width()
        if (widthWoc <= 1380) {
            let H = $('.C_warp').width() * 0.38;
            _Warp.setState({
                hei:H,
                smWidth:"100%",
                lgWidth:"100%"
            })
        } else {
            let H = $('.C_warp').width() * 0.66 * 0.38;
            _Warp.setState({
                hei:H,
                smWidth:"34%",
                lgWidth:"66%"
            })
        }
    }

    //动态重置布局
    setHeight() {
        _Warp.startSet();
        $(window).resize(function () {
            _Warp.startSet()
        })
    }
    componentWillMount(){
        let _this = this
        $.ajax({
            url: Hcurl + "/HomePage/GetDepartmentUserWorkItemInfo?UserCode=" + EventSet.getUserInfo().CU_Code+"&comCode=" + EventSet.getUserInfo().xxhjcompanycode,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                console.log('25',res)
                _this.setState({
                    num:res[0]
                })
                
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    //组件完成后事件
    componentDidMount() {
        _Warp = this;
        this.setHeight()
        this.openNotification()
    //    window.location.reload()
    }
    openNotification = () => {
        var tipsText = '';
        let t = JSON.parse(localStorage.userInfo)
        let token = t.token
        $.ajax({
            url: Hcurl + '/AF_CompanyCaseInfo/GetNoticeMessage',
            async:false,
            headers: {
                "token": token
            },
            type: 'post',
            success: function (res) {
                _Warp.setState({
                    text:res.replace(/\n/g,'臡')
                })
            }
        })

    };
    //组件的渲染
    render() {
        return (
            <div id="Home" style={{background:"#fff"}}>
                <Crumbs title={"首页"}/>
                <div className={"content"}  >
                    <div className="C_warp clear">
                        {this.state.num.hasOtherUnDealCount>0? <Alert style={{marginBottom:'12px'}} message="您关联的其他主体中有待办项未处理，您可以切换至相应的主体进行处理" type="warning" showIcon />:''}
                   

                       
                        <div className="C_lager" style={{ width: '100%',height:this.state.hei}}>
                            <Chart hei={this.state.hei}/>
                        </div>

                         {/* <div className="C_small" style={{width:this.state.smWidth,height:this.state.hei}}>
                            <Law hei={this.state.hei}/>
                        </div> */}
                             

                        <div className="C_lager" style={{width:this.state.lgWidth,height:this.state.hei}}>
                            <Notice hei={this.state.hei}/>
                        </div>
                        <div className="C_small"  style={{width:this.state.smWidth,height:this.state.hei}}>
                            <Node hei={this.state.hei}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App




// WEBPACK FOOTER //
// ./src/components/Content/Home/Home.js